export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/translation.81c0230.svg";